/*
/**
 Set following line to true when deploying to LIVE Environment
*/
import * as firebase from 'firebase';
//import "firebase/compat/storage";

// Firebase project configuration params DEVELOPMENT
const firebaseConfig = {
	apiKey: "AIzaSyCOVnMGa59nWGUHeZvSX7Q0HTsG3kMiWpE",
	authDomain: "dogmoticswebapp.firebaseapp.com",
	databaseURL: "https://dogmoticswebapp.firebaseio.com",
	projectId: "dogmoticswebapp",
	storageBucket: "dogmoticswebapp.appspot.com",
	messagingSenderId: "244611063061",
	appId: "1:244611063061:web:6955b30ca96290a4f49d1c",
};

const stripeConfig = {
	dev_mi1: "pk_test_jqg4igaWIqcMjvKloEyJLfrQ00y19avHFQ",
	prd_mi1: "pk_live_k45hAohtgpAOVTi3RexWLwWw00lK9YRote",
	dev_lc1: "pk_test_51MZI95H6rVHs0Pr67qSwL7NzbjH0KyUfbqHh4IgiPl2d9AnZ0T02xGtLlauobuxmPg3Lb9DpoMIrqU0mwodWy9sz00UMnLMWvD",
	prd_lc1: "pk_live_51MZI95H6rVHs0Pr6dI4AMEZa2CL9cQSGFpkq6XK2ZhSXf9nZcXo2QCGuDMqg4njs036SkgMJtAtCQg0RwqBwVWTy00dnbikSDw"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const timestamp = firebase.firestore.FieldValue.serverTimestamp();
const db = firebaseApp.firestore();
const auth = firebaseApp.auth();	
const functions = firebaseApp.functions();
const storage = firebaseApp.storage();

export { firebaseApp, firebase, timestamp, db, auth, functions, storage, stripeConfig }